import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App'
import CONSTANTS from './Constants'
import './index.scss'
import { persistor, store } from './Store'

// Sentry initialization
if (
  CONSTANTS.SENTRY_ENABLE === 'true' && // Toggle Sentry based on the env variable
  CONSTANTS.SENTRY_DSN // Ensure DSN is provided
) {
  Sentry.init({
    enabled: true, // Sentry is explicitly enabled
    dsn: CONSTANTS.SENTRY_DSN,
    environment: CONSTANTS.APP_ENV || 'development', // Default to 'development' if not set
    integrations: [
      // Add integrations as needed
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

if (CONSTANTS.APP_ENV === 'Production') {
  console.log = function () {
    return
  }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
)
